import React from 'react';

import Display from '@dashboard/components/Display';
import KeyChip from '@dashboard/components/KeyChip';
import { Box, Link, Stack, Typography } from '@mui/material';

import { useCurrentTemplateType } from '../../hooks';

import ScenarioSelection from './ScenarioSelection';
import StrictRenderingCheckboxField from './StrictRenderingCheckboxField';
import TestDataInput from './TestDataInput';

export default function DataSidebar() {
  const type = useCurrentTemplateType();
  return (
    <Stack spacing={5} sx={{ p: 3, overflow: 'auto', height: '100%' }}>
      <Box>
        <Typography variant="overline" component="h2" color="text.secondary">
          Test data
        </Typography>
        <Typography paragraph color="text.secondary">
          Mimic the{' '}
          <Link href="https://www.usewaypoint.com/docs/template-test-data" target="_blank">
            JSON data
          </Link>{' '}
          that your application will pass to this template. Example: <KeyChip label='{ "displayName": "Joe" }' />
        </Typography>
        <Typography paragraph color="text.secondary">
          Output and format variables on your template using{' '}
          <Link href="https://www.usewaypoint.com/docs/formatting-data/" target="_blank">
            Liquid syntax
          </Link>
          . Example: <KeyChip label="{{ 40.5 | currency }}" />
        </Typography>

        <Stack spacing={0.5}>
          <ScenarioSelection />
          <TestDataInput />
        </Stack>

        <Display display={type === 'LAYOUT'}>
          <Box mt={2}>
            <Typography variant="body2" color="text.secondary">
              Test data set on this layout will be available as variables within your nested templates.
            </Typography>
          </Box>
        </Display>
      </Box>

      <Display display={type === 'TEMPLATE'}>
        <Box>
          <Typography variant="overline" component="h2" color="text.secondary">
            Data options
          </Typography>

          <StrictRenderingCheckboxField />
        </Box>
      </Display>
    </Stack>
  );
}
